import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { 
    ActivatedRouteSnapshot, 
    CanActivate, 
    Router, 
    RouterStateSnapshot, 
    UrlTree 
} from '@angular/router';
import { PublicService } from '../services/public.service';
import { PublicRoutesEnum } from '../interfaces/public-routes.enum';
import { Schedule } from '../interfaces/schedule.model';
import { ScheduleResponse } from '../interfaces/schedule-reponse.model';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationGuard implements CanActivate {

    private publicScheduleData!: Schedule;
    private scheduleResponseData!: ScheduleResponse;

    constructor(
        private router: Router,
        private publicService: PublicService,
    ) {
        this.publicService.onPublicScheduleSuccessData.subscribe(data => {
            this.scheduleResponseData = data;    
        });
        this.publicService.onPublicScheduleData.subscribe(data => {
            this.publicScheduleData = data;    
        })
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): 
        boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (this.scheduleResponseData) {
            return true;
        } else {
            this.router.navigate([
                `${this.publicScheduleData.client_key}/${PublicRoutesEnum.SUMMARY}`
            ]);
            return false;
        }
    }

}